import _ from "lodash";

import nxModule from 'nxModule';
import systemPropertyService from 'system/systemPropertyService';
import './report-view.style.less';

const templateUrl = require('./report-view.template.html');

// These are the backend's report header keys, not display labels: the template renders the key
// itself as the label, and any key missing from this list is dropped by keepOnlyKeysCaseInsensitive.
const commonReportDescriptionToKeepInOrder = [
  "Organization",
  "Branch",
  "Branch name",
  "TIN",
  "Report name",
  "Generated on",
  "Generated by",
  "Checked by",
  "Approved by",
  'Start date',
  'End date',
  'Date'
];

// Backends up to and including the stage line still send the TIN under the older "TIN number" key.
// Fold it into "TIN" so the header works whichever backend this build is pointed at.
const LEGACY_TIN_KEY = "TIN number";
const TIN_KEY = "TIN";

const normaliseTinKey = (headers) => {
  if (!headers[TIN_KEY] && headers[LEGACY_TIN_KEY]) {
    headers[TIN_KEY] = headers[LEGACY_TIN_KEY];
  }
  delete headers[LEGACY_TIN_KEY];
};

const keepOnlyKeysCaseInsensitive = (obj, keys) => {
  const lowerCaseKeys = keys.map(key => key.toLowerCase());
  Object.keys(obj).forEach(key => {
    if (!lowerCaseKeys.includes(key.toLowerCase())) {
      delete obj[key];
    }
  });
};

const orderHeadersAndAddIfNotAvailable = (headers) => {
  const orderedHeaders = {};

  // Add the specific headers to the orderedHeaders object, ensuring blank values if missing
  commonReportDescriptionToKeepInOrder.forEach(header => {
    orderedHeaders[header] = headers[header] || "";
  });

  // Add the remaining headers that are not in the specific order
  for (const key in headers) {
    if (!commonReportDescriptionToKeepInOrder.includes(key)) {
      orderedHeaders[key] = headers[key];
    }
  }

  return orderedHeaders;
}


nxModule.component('reportView', {
  templateUrl,
  bindings: {
    reportContent: '<',
    container: '<',
    lazyDisplay: '<', // if not present, default value is true
    descriptor: '<'
  },
  controller: function ($scope) {
    const that = this;
    that.container = that.container || null;
    that.lazyDisplay = that.lazyDisplay ?? true;
    that.truncateLongReportValue = systemPropertyService.getProperty('REPORT_VIEW_TRUNCATE_LONG_VALUE') === 'TRUE';

    $scope.$watch('$ctrl.reportContent', () => {
      if (!that.reportContent) return;

      that.reportGenerated = true;
      that.reportColumnsNum = findColumnNumber(that.reportContent);
      that.hasData = checkIfHasData(that.reportContent);

      if (that.descriptor && that.descriptor.outputTypes && that.descriptor.outputTypes.includes('XLS', 'CSV')) {
        normaliseTinKey(that.reportContent[0].reportDescription);
        keepOnlyKeysCaseInsensitive(that.reportContent[0].reportDescription, commonReportDescriptionToKeepInOrder);
        that.reportContent[0].reportDescription = orderHeadersAndAddIfNotAvailable(that.reportContent[0].reportDescription);
      }

      that.reportContent.forEach(sheet => sheet.limit = 100);
    });

    that.increaseLimit = () => {
      if (!that.reportContent || !that.lazyDisplay) {
        return;
      }

      const notFullyDisplayedSheet = that.reportContent.find(sheet => sheet.limit < sheet.rows.length);
      if (notFullyDisplayedSheet) {
        notFullyDisplayedSheet.limit += 100;
      }
    };

    function checkIfHasData(reports) {
      return _(reports).map((r) => r.rows).flatten().value().length > 0
    }

    function findColumnNumber(reports) {
      return _(reports).map((report) => {
        return _(report.rows).map((a) => a.cells.length + report.xoffset).max();
      }).max();
    }

  }
});
